export default __webpack_public_path__ + "static/media/icon_chevron_smaller_down.fd692461.svg";